<app-mrp-scrolltop></app-mrp-scrolltop>
<!-- Main -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">

      <div class="row">
        <div class="col-12-large">

          <div>
            <img src="assets/images/precinct/timeline.png" alt="Convention Timeline" class="hero-header-img">
          </div>


          <div class="right-menu">
            <mat-form-field appearance="fill">
              <mat-label>Tools...</mat-label>
              <mat-select (selectionChange)="onRouteSelect($event.value)">
                @for (routeOption of delegateroutes; track routeOption) {
                <mat-option [value]="routeOption.path">
                  {{ routeOption.label }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <h4><b>Convention Cycle</b></h4>

          <p>The Repbuplican Party operates on a two year election cycle.</p>
          <p>Every two years county and state conventions are held to elect new leadership which coincides with the two
            year election cycle of state representatives and local county officials.</p>


        </div>

        <div class="col-12-large ">

          <h4><b>Even Year Election</b></h4>

          <h5><b>April</b></h5>

          <p><b>April 1, 2024:</b>
            Deadline for county chairs to submit precinct delegate apportionment count for next 2-year term to County
            Clerk.
            This count determines how many seats are available in your precinct.
          </p>

          <h5><b>First Week of May</b></h5>

          <b>May 7, 2024</b>
          <p>Filing Deadline for Precinct Delegate Affidavit of Identity</p>

          <ul>
            <li>Complete your <a
                href="https://www.michigan.gov/sos/-/media/Project/Websites/sos/25delrio/Aff-ID_Precnt_139901_7.pdf">Affidavit
                of Identity</a></li>
            <li>Notarize it</li>
            <li>File it with the County Clerk prior to filing deadline</li>
          </ul>

        </div>

      </div>
    </div>
  </div>
</section>

<!-- section 2 -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">

      <div class="row">
        <div class="col-12-large">

          <h5 class=""><b>Statewide Endorsement Conventions</b></h5>

          <b>Spring 2026</b>
          <p>County Endorsement Convention</p>

          <b>Spring 2026</b>
          <p>State Endorsement Convention</p>

          <p>Endorse major state office candidates for Secretary of State, Attorney General, Supreme Court Justices (2),
            Board of Education (2), University Boards of WSU, UOM and MSU (2 each).
          </p>


          <blockquote>
            <p>"They who can give up essential liberty to obtain a little temporary safety deserve neither liberty nor
              safety.""
              -Benjamin Franklin</p>
          </blockquote>
        </div>

        <div class="col-12-large ">

          <h5 class=""><b>Conventions for National</b></h5>

          <b>February 15, 2024</b>
          <p>Spring County Convention</p>
          <p>Elect delegates for Spring State Convention.</p>

          <b>March 2, 2024</b>
          <p>Spring State Convention</p>
          <p>Elect 3 delegates from each congressional district to attend Republican National Convention.
            Elect National Committeeman.</p>

        </div>

      </div>
    </div>
  </div>
</section>


<!-- section 3 -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">

      <div class="row">
        <div class="col-12-large">

          <h5 class=""><b>May thru July</b></h5>

          <b>Primary Election Campaign Season</b>
          <p>Campaign, support and promote Republican candidates on the ballot.</p>


          <h5 class=""><b>August</b></h5>

          <b>August 6, 2024 </b>
          <b>Primary Election Campaign Season</b>
          <p>VOTE! Today precinct delegates are elected.</p>
        </div>

        <div class="col-12-large ">

          <h5 class=""><b>Fall Nomination Conventions</b></h5>

          <b>August 2024 </b>
          <b>Fall County Convention</b>
          <p>Elect State Delegates to attend Fall State Convention.</p>


          <b>August 2024 </b>
          <b>Fall State Convention</b>
          <p>Statewide Election Year: Nominate major state office candidates for Lieutenant Governor, Secretary of
            State, Attorney General, 2x Supreme Court Justices, 2x Board of Education, 2x University Boards of WSU, UOM
            and MSU,
            Presidential Election Year: Nominate Presidential Electors, 2x Supreme Court Justices, 2x Board of
            Education, 2x University Boards of WSU, UOM and MSU </p>


          <b>Fall 2024 </b>
          <b>Fall National Convention</b>
          <p>Nominate President and Vice President of the United States.</p>

        </div>

      </div>
    </div>
  </div>
</section>


<!-- section 4 -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">

      <div class="row">
        <div class="col-12-large">

          <h5 class=""><b>September and October</b></h5>

          <b>General Election Campaign Season </b>
          <p>Promote Republican Party candidates and ballot proposals.</p>

          <h5 class=""><b>November</b></h5>

          <b>Nov 5th, 2024 </b>
          <b>General Election Day </b>
          <p>VOTE. Everyone must vote.</p>

          <b>November 2024 </b>
          <b>Post-Election County Convention</b>
          <p>Elect members to serve on the County Executive Committee for 2-year terms.
            The newly elected Executive Committee must meet to elect the county party officers: Chair, Vice Chair,
            Secretary and Treasurer within thirty days of this convention.
          </p>


        </div>

        <div class="col-12-large ">

          <h4><b>Odd Year Conventions</b></h4>
          <h5 class=""><b>Spring Conventions</b></h5>

          <b>Winter 2025 </b>
          <b>Spring County Convention</b>
          <p>Elect State Delegates to attend District Caucus and Spring State Convention</p>

          <b>Winter 2025 </b>
          <b>Spring State Convention</b>
          <p>For District Committees, elect Chair, Vice Chair, Secretary, Treasurer, 6 State Committee Members
            to serve on the Congressional District Committee for 2 year terms. </p>
          <p>For State Committee, elect Chair, Co-Chair and 6 Vice Chairs for a 2-year term.</p>


        </div>

      </div>
    </div>
  </div>
</section>
<!---------------------END OF PAGE ---------------------------------------------------------------->